import { registerLocale, setLocale, LocaleId, LocalizeItem, getLocale } from '@omegagrid/localize';
import { events } from '@omegagrid/core';
import type { Container } from './container';

export class Localization extends EventTarget {

	#data = new Map<LocaleId, LocalizeItem[]>();
	#activeLocale: LocaleId | null = null;

	constructor(readonly container: Container) {
		super();
	}

	async setLocale(id: LocaleId) {
		id = id.split('-')[0] as LocaleId;

		if (!this.#data.has(id)) {
			let url = `${this.container.options.staticUrl}/locale/${id}.json?${this.container.options.appHash || ''}`;
			try {
				const data = await (await fetch(url)).json();
				this.#data.set(id, data);
				registerLocale(id, data);
			} catch (error) {
				console.error(`Locale ${id} not found`);
				return;
			}
		}

		if (!this.#data.has(id)) {
			console.error(`Locale ${id} not found`);
		} else if (this.#activeLocale !== id) {
			this.#activeLocale = id;
			setLocale(id);
			this.dispatchEvent(new events.ChangeEvent(id));
		}
	}

	async setDefaultLocale() {
		await this.setLocale(getLocale());
	}

}
